'use strict';
// TODO: Remove from `core-js@4`
require('../modules/es.set.is-disjoint-from.v2');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/esnext.set.is-disjoint-from.v2.js
// module id = 1502
// module chunks = 0